const SUPPORTED_PORTAL_ROLES = new Set(["client", "expert", "platform"]);

const PRODUCTION_FOUNDATION_ORIGINS = new Set([
  "https://ykq5580.com",
  "https://www.ykq5580.com",
]);

const LOCAL_FOUNDATION_PORTS = Object.freeze({
  client: "5198",
  expert: "5194",
  platform: "5199",
});

const LOCAL_FOUNDATION_HOSTS = new Set(["127.0.0.1", "localhost", "[::1]"]);

export const FOUNDATION_SYSTEM_CODE = "templates";

function parsedUrl(value) {
  try {
    return new URL(String(value || ""));
  } catch {
    return null;
  }
}

function isTrustedFoundationOrigin(url, portalRole) {
  if (PRODUCTION_FOUNDATION_ORIGINS.has(url.origin)) return true;

  // 中文维护注释：本地三端必须回到各自真实底座端口，禁止平台端借用客户端 5198 身份。
  return url.protocol === "http:"
    && LOCAL_FOUNDATION_HOSTS.has(url.hostname)
    && url.port === LOCAL_FOUNDATION_PORTS[portalRole];
}

export function resolveFoundationParentOrigin({ portalRole, search, referrer, isEmbedded }) {
  const params = new URLSearchParams(search || "");
  if (
    !SUPPORTED_PORTAL_ROLES.has(portalRole)
    || !isEmbedded
    || params.get("foundationBridge") !== "1"
    || params.get("foundationSystemCode") !== FOUNDATION_SYSTEM_CODE
  ) return "";

  const declaredParentValue = params.get("parentOrigin") || "";
  const declaredParent = parsedUrl(declaredParentValue);
  const actualReferrer = parsedUrl(referrer);
  if (!declaredParent || !actualReferrer) return "";

  // 中文维护注释：查询参数只用于声明，必须与浏览器真实 referrer 完全同源，并落在受信生产域或角色对应的本地端口。
  if (declaredParentValue !== declaredParent.origin || declaredParent.origin !== actualReferrer.origin) return "";
  return isTrustedFoundationOrigin(actualReferrer, portalRole) ? actualReferrer.origin : "";
}

export function isTrustedFoundationMessage(event, expectedSource, expectedOrigin) {
  return Boolean(
    event
    && event.source === expectedSource
    && event.origin === expectedOrigin
    && event.data
    && typeof event.data === "object",
  );
}
